import {
  GET_TERMS_CONDITIONS_REQUEST,
  CREATE_TERMS_CONDITIONS_REQUEST,
  UPDATE_TERMS_CONDITIONS_REQUEST,
  DELETE_TERMS_CONDITIONS_REQUEST,
} from '../types/termsConditions'

export const getTermsConditions = (payload = {}) => ({
  type: GET_TERMS_CONDITIONS_REQUEST,
  payload,
})

export const createTermsConditions = (payload) => ({
  type: CREATE_TERMS_CONDITIONS_REQUEST,
  payload,
})

export const updateTermsConditions = (payload) => ({
  type: UPDATE_TERMS_CONDITIONS_REQUEST,
  payload,
})

export const deleteTermsConditions = (payload) => ({
  type: DELETE_TERMS_CONDITIONS_REQUEST,
  payload,
})
